import * as helper from './../../../../../VX/View/Assets/Js/helper';

export default class Counter {
	constructor(mainElement) {
		this.numbers = mainElement.querySelectorAll('div');
		this.active = 1;
	}

	next() {
		helper.removeClass(this.numbers[this.active - 1], 'active');
		this.active++;
		helper.addClass(this.numbers[this.active - 1], 'active');
	}
}
